module.exports = __webpack_public_path__ + "img/3.05411380.png";